import {Message as _Message} from './Messages.js';
import {UserLogin} from './UserLogin.js';
import {BreadCrumbs} from './BreadCrumbs.js';
export class lateral {
	constructor() {

	}
}
(function() {
	lateral.script = document.currentScript;
	const u = URL.parse(lateral.script.getAttribute("src"), document.URL);
	lateral.origin = u.origin;
})();
document.addEventListener(`DOMContentLoaded`, ()=>{ new lateral(); });